import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'

/**
 * v7 `.phead` — sticky page header shared by Home, the Experience list and
 * the Experience detail chrome.
 *
 * @example
 * <ExperiencePageHead title='Home' subtitle='What needs attention today.'>
 *   <button className='btn-outline-experience'>All experiences</button>
 * </ExperiencePageHead>
 */
const ExperiencePageHead = ({
  title,
  subtitle,
  crumb,
  titleAfter,
  className,
  children,
  actsRef,
}) => (
  <header className={classNames('experience-phead', className)}>
    <div className='experience-grow'>
      {crumb ? <p className='experience-crumb'>{crumb}</p> : null}
      <h1>
        {title}
        {titleAfter}
      </h1>
      {subtitle ? <p className='experience-phead-sub'>{subtitle}</p> : null}
    </div>
    {children ? (
      <div className='experience-acts' ref={actsRef}>
        {children}
      </div>
    ) : null}
  </header>
)

ExperiencePageHead.propTypes = {
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.node,
  crumb: PropTypes.node,
  titleAfter: PropTypes.node,
  className: PropTypes.string,
  children: PropTypes.node,
  actsRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]),
}

export default ExperiencePageHead
